"use client";
import { useState } from "react";
import type { HorizonItem } from "../../../data";

interface UseHorizonInput {
  items: HorizonItem[];
  min: number;
  // "{n} of {total} items by {year}".
  countTemplate: string;
}

// The "Look ahead to" slider: every item dated up to the chosen year is
// reached; later ones stay faded.
export function useHorizon({ items, min, countTemplate }: UseHorizonInput) {
  const initialState = { year: min };
  const [state, setState] = useState(initialState);

  const setYear = (year: number) => setState((state) => ({ ...state, year }));

  const isReached = (item: HorizonItem) => item.year <= state.year;
  const reachedCount = items.filter(isReached).length;
  const countText = countTemplate
    .replace("{n}", String(reachedCount))
    .replace("{total}", String(items.length))
    .replace("{year}", String(state.year));

  return { year: state.year, setYear, isReached, countText };
}
